import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import Utils from '@shared/utils/utils';
import Configs from '@shared/constants/configs';
import Roles from '@shared/constants/roles';
import { DeviceDetectorService } from 'ngx-device-detector';

@Component({
  selector: 'app-dp-form-data-file-select',
  templateUrl: './dp-form-data-file-select.component.html',
  styleUrls: ['./dp-form-data-file-select.component.scss']
})
export class DpFormDataFileSelectComponent implements OnInit {
  readonly configs = Configs;
  readonly roles = Roles;
  @Output()
  showFile = new EventEmitter();
  @Output()
  outFile = new EventEmitter();
  @Output()
  fileDelete = new EventEmitter();
  files: any[] = [];
  file: any;
  isMobile = false;
  @ViewChild('imgFileInput') imgFileInput: ElementRef;

  constructor(private deviceService: DeviceDetectorService) {
  }

  _initInfo: any;

  @Input()
  set initInfo(value) {
    if (!value) {
      return
    }
    this._initInfo = value;
  };

  ngOnInit(): void {
    this.isMobile = this.deviceService.isMobile();
  }

  fileSelected(event): any {
    const files = event.target.files;

    this.files = files;

    if (this.files.length > 0) {
      const overLimit = Array.from(this.files).some((f: any) => {
        return (f.size > this.configs.fileLimit.limit);
      });

      if (overLimit) {
        this.imgFileInput.nativeElement.value = '';
        const size = (this.configs.fileLimit.limit / (1024 * 1024)).toFixed(0);
        Utils.showError({ message: `The file is too large.  Please select size ${ size }MB or less.` });
        return false;
      }
    }

    this.file = files[0];
    this.outFile.emit(this.file);
  }

  delete() {
    this.fileDelete.emit(this.file);
    this.file = null;
    this.files = [];
  }

  clickFile() {
    this.showFile.emit(true)
  }
}
